/*
 * PanelPartners — levertijd van de hele bestelling in de Kaching slide-cart.
 * Haalt de server-side berekende schatting op via de Section Rendering API
 * (/?sections=cart-delivery-estimate) en injecteert die bovenin de Kaching-footer.
 * De berekening (traagste product wint) gebeurt in Liquid; JS plaatst alleen.
 */
(function () {
  var SLOT_ID = 'pp-cart-delivery-slot';
  var SECTION = 'cart-delivery-estimate';
  var cachedHTML = '';
  var refetchTimer = null;

  function inject() {
    var footer = document.querySelector('.kaching-cart__footer');
    if (!footer) return;
    var slot = document.getElementById(SLOT_ID);
    if (!cachedHTML) {
      if (slot) slot.remove();
      return;
    }
    if (!slot) {
      slot = document.createElement('div');
      slot.id = SLOT_ID;
      footer.insertBefore(slot, footer.firstChild);
    } else if (slot.parentNode !== footer) {
      footer.insertBefore(slot, footer.firstChild);
    }
    if (slot.getAttribute('data-html') !== cachedHTML) {
      slot.innerHTML = cachedHTML;
      slot.setAttribute('data-html', cachedHTML);
    }
  }

  function fetchDelivery() {
    fetch('/?sections=' + SECTION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        cachedHTML = ((j && j[SECTION]) || '').trim();
        inject();
      })
      .catch(function () {});
  }

  function scheduleRefetch() {
    if (refetchTimer) clearTimeout(refetchTimer);
    refetchTimer = setTimeout(fetchDelivery, 400);
  }

  function onCartMutate(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (t && t.closest && t.closest('#' + SLOT_ID)) continue; // negeer onze eigen wijziging
      inject();          // herstel het blok als Kaching de footer opnieuw rendert
      scheduleRefetch(); // ververs de tekst als de inhoud van de cart wijzigde
      return;
    }
  }

  function attach() {
    var cart = document.getElementById('kaching-cart');
    if (cart && !cart.__ppDeliveryObserved) {
      cart.__ppDeliveryObserved = true;
      new MutationObserver(onCartMutate).observe(cart, { childList: true, subtree: true });
      if (!cachedHTML) fetchDelivery(); else inject();
    }
  }

  function boot() {
    // Vang het verschijnen/herbouwen van de Kaching-cart in de DOM op.
    new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
    // Fetch zodra de slide-cart opent.
    new MutationObserver(function () {
      if (document.body.classList.contains('kaching-body__cart-open')) fetchDelivery();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    attach();
    if (document.body.classList.contains('kaching-body__cart-open')) fetchDelivery();
  }

  if (document.body) boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
